import { createSportsBookList } from './index';

export const list = createSportsBookList([
  {
    slug: 'bets',
    type: 'page',
    i18nLabel: 'sidebar.my_bets',
    icon: {
      name: 'ticket',
    },
    path: {
      cactus: {
        'betting-history': true,
      },
      betby: '/bets',
      altenar: {
        page: 'betHistory',
      },
    },
  },
  {
    slug: 'live',
    type: 'page',
    i18nLabel: 'header.live',
    icon: {
      name: 'tv',
    },
    path: {
      cactus: {
        tab: 'Live',
      },
      betby: '/live',
      altenar: {
        page: 'live',
      },
    },
  },
  {
    slug: 'upcoming',
    type: 'page',
    i18nLabel: 'sidebar.starts_soon',
    icon: {
      name: 'timer',
    },
    path: {
      cactus: {
        eventlistTab: 'Upcoming',
      },
      betby: '/',
      altenar: {
        page: 'overview',
      },
    },
  },
  {
    slug: 'brasil/brasileirao-serie-a',
    type: 'championship',
    i18nLabel: 'sidebar.brasileirao_A',
    icon: {
      path: 'flags/BRA',
    },
    path: {
      cactus: {
        masterLeagueId: '530',
      },
      betby: '/soccer/brazil/brasileiro-serie-a-1669818812230406144',
      altenar: {
        page: 'championship',
        championshipIds: [11318],
      },
    },
  },
  {
    slug: 'america-do-sul/copa-libertadores',
    type: 'championship',
    i18nLabel: 'sidebar.libertadores',
    icon: {
      path: 'flags/INTER',
    },
    path: {
      cactus: {
        masterLeagueId: '133',
      },
      betby: '/fifa/south-america/copa-libertadores-1670104311276900352',
      altenar: {
        page: 'championship',
        championshipIds: [3709],
      },
    },
  },
  {
    slug: 'inglaterra/premier-league',
    type: 'championship',
    i18nLabel: 'sidebar.english_championship',
    icon: {
      path: 'flags/ENG',
    },
    path: {
      cactus: {
        masterLeagueId: '24',
      },
      betby: '/soccer/england/premier-league-1669818860469096448',
      altenar: {
        page: 'championship',
        championshipIds: [2936],
      },
    },
  },
  {
    slug: 'espanha/laliga',
    type: 'championship',
    i18nLabel: 'sidebar.spanish_championship',
    icon: {
      path: 'flags/ESP',
    },
    path: {
      cactus: {
        masterLeagueId: '38',
      },
      betby: '/soccer/spain/laliga-1669819032615915520',
      altenar: {
        page: 'championship',
        championshipIds: [2941],
      },
    },
  },
  {
    slug: 'italia/serie-a',
    type: 'championship',
    i18nLabel: 'sidebar.italian_championship',
    icon: {
      path: 'flags/ITA',
    },
    path: {
      cactus: {
        masterLeagueId: '74',
      },
      betby: '/soccer/italy/serie-a-1669819042829045760',
      altenar: {
        page: 'championship',
        championshipIds: [2942],
      },
    },
  },
  {
    slug: 'franca/liga-1',
    type: 'championship',
    i18nLabel: 'sidebar.french_championship',
    icon: {
      path: 'flags/FRA',
    },
    path: {
      cactus: {
        masterLeagueId: '25',
      },
      betby: '/soccer/france/ligue-1-1669818844560101376',
      altenar: {
        page: 'championship',
        championshipIds: [2943],
      },
    },
  },
  {
    slug: 'alemanha/bundesliga',
    type: 'championship',
    i18nLabel: 'sidebar.german_championship',
    icon: {
      path: 'flags/DEU',
    },
    path: {
      cactus: {
        masterLeagueId: '110',
      },
      betby: '/soccer/germany/bundesliga-1669818934959935488',
      altenar: {
        page: 'championship',
        championshipIds: [2950],
      },
    },
  },
  {
    slug: 'europa/uefa-champions-league',
    type: 'championship',
    i18nLabel: 'sidebar.champions_league',
    icon: {
      path: 'flags/UEFA',
    },
    path: {
      cactus: {
        masterLeagueId: '125',
      },
      betby:
        '/soccer/international-clubs/uefa-champions-league-1669819100844658688',
      altenar: {
        page: 'championship',
        championshipIds: [16808],
      },
    },
  },
  {
    slug: 'usa/nba',
    type: 'championship',
    i18nLabel: 'sidebar.nba',
    icon: {
      path: 'flags/NBA',
    },
    path: {
      cactus: {
        masterLeagueId: '29',
      },
      betby: '/basketball/usa/nba-1669819088278523904',
      altenar: {
        page: 'championship',
        championshipIds: [2980],
      },
    },
  },
  {
    slug: 'usa/nfl',
    type: 'championship',
    i18nLabel: 'sidebar.nfl',
    icon: {
      path: 'flags/NFL',
    },
    path: {
      cactus: {
        masterLeagueId: '40',
      },
      betby: '/american-football/usa/nfl-1669818837568196608',
      altenar: {
        page: 'championship',
        championshipIds: [3281],
      },
    },
  },
  {
    slug: 'formula-1',
    type: 'championship',
    i18nLabel: 'sidebar.f1',
    icon: {
      path: 'flags/F1',
    },
    path: {
      cactus: {
        sportId: '14',
      },
      betby: '/formula-1-40',
    },
  },
  {
    slug: 'soccer',
    type: 'sport',
    i18nLabel: 'sidebar.football',
    icon: {
      name: 'futbol',
    },
    path: {
      cactus: {
        sportId: '1',
      },
      betby: '/soccer-1',
      altenar: {
        page: 'sport',
        sportId: 66,
      },
    },
  },
  {
    slug: 'tennis',
    type: 'sport',
    i18nLabel: 'sidebar.tennis',
    icon: {
      name: 'tenisball',
    },
    path: {
      cactus: {
        sportId: '6',
      },
      betby: '/tennis-5',
      altenar: {
        page: 'sport',
        sportId: 68,
      },
    },
  },
  {
    slug: 'basketball',
    type: 'sport',
    i18nLabel: 'sidebar.basketball',
    icon: {
      name: 'basketball',
    },
    path: {
      cactus: {
        sportId: '2',
      },
      betby: '/basketball-2',
      altenar: {
        page: 'sport',
        sportId: 67,
      },
    },
  },
  {
    slug: 'volleyball',
    type: 'sport',
    i18nLabel: 'sidebar.volleyball',
    icon: {
      name: 'volleyball',
    },
    path: {
      cactus: {
        sportId: '19',
      },
      betby: '/volleyball-23',
      altenar: {
        page: 'sport',
        sportId: 69,
      },
    },
  },
  {
    slug: 'e-sports',
    type: 'sport',
    i18nLabel: 'sidebar.virtual_sports',
    icon: {
      name: 'gamepad',
    },
    path: {
      cactus: {
        sportId: '64',
      },
      betby: '/300',
      altenar: {
        page: 'esports',
      },
    },
  },
  {
    slug: 'vaquejada-237',
    type: 'sport',
    i18nLabel: 'Vaquejada',
    icon: {
      name: 'horse',
    },
    path: {
      betby: '/vaquejada-237',
    },
  },
  {
    slug: 'x1-motocross',
    type: 'sport',
    i18nLabel: 'Motocross',
    icon: {
      name: 'motocross',
    },
    path: {
      betby: '/x1-ao-vivo/x1-motocross/x1-motocross-2373671881971732490',
    },
  },
  {
    slug: 'x1-ao-vivo',
    type: 'sport',
    i18nLabel: 'home.x1',
    icon: {
      name: 'x1',
    },
    path: {
      betby: '/x1-ao-vivo-237',
    },
  },
]);
